import { connect } from 'react-redux';
import { formatCurrencyUSD } from '../utils/utility.js';
import PaymentCalculator from '../components/views/loaded/PaymentCalculator';
import { resetCalculator } from '../actions/updateCalculator';

const mapStateToProps = state => {
	return {
		showDisclaimer: state.prefs.showDisclaimer === 'true',
		price: formatCurrencyUSD(state.calculatorData.initial.price),
		monthlyPayment: formatCurrencyUSD(
			state.calculatorData.current.monthlyPayment
		)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		resetCalculator: () => {
			dispatch(resetCalculator());
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PaymentCalculator);



// WEBPACK FOOTER //
// ./src/containers/PaymentCalculatorController.jsx